import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import styles from "../../../../propertydetails.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";
import KeyFobCard from "./KeyFobCard";
import { Plus, X } from "react-feather";

const schema = yup.object().shape({
    title: yup.string().required("This field is Required"),
    card_number: yup.string().required("This field is Required")
});

const PropertyKeyFobs = ({ property_id, property_name, keyfobs, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [editFormData, setEditFormData] = useState(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deletedId, setDeletedId] = useState(0);

    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (editFormData) {
            setValue('title', editFormData.title);
            setValue('card_number', editFormData.card_number);
        }
    }, [editFormData, setValue]);

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-keyfobs/" + property_id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setIsFormOpen(false);
            setEditFormData(null);
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                let keyfobs = prev.keyfobs.concat([response.data.data]);
                return { ...prev, keyfobs: keyfobs };
            });

            let logData = {
                title: "Door lock keyfob is added",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);

            axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/add-master-key-fob/" + response.data.data?.id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-keyfobs/" + property_id + "/" + editFormData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setIsFormOpen(false);
            setEditFormData(null);
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                let keyfobs = prev.keyfobs?.map(i => {
                    if (i?.id === editFormData?.id)
                        return response.data.data;
                    return i;
                });
                return { ...prev, keyfobs: keyfobs };
            });

            let logData = {
                title: "Door lock keyfob is updated",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);

            axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/add-master-key-fob/" + editFormData?.id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const deleteConfirm = async () => {
        setOpenDeleteModal(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.delete(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-keyfobs/" + property_id + "/" + deletedId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setIsFormOpen(false);
            setEditFormData(null);
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let cardNumber = keyfobs?.filter(i => i?.id === deletedId);

            setPropertyData((prev) => {
                let keyfobs = prev.keyfobs?.filter(i => i?.id !== deletedId);
                return { ...prev, keyfobs: keyfobs };
            });

            setDeletedId(0);

            let logData = {
                title: "Door lock keyfob is deleted",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);

            axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/delete-master-key-fob/" + property_id + "/" + cardNumber[0]['card_number'], {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return <div>

        {keyfobs?.length === 0 && !isFormOpen && <div className={`${styles.NoPinSec}`}>
            <div>
                <img src="/static/img/noDoorPin.svg" alt="" />
                <p>No Key Fobs Are Available</p>
                <button onClick={(e) => { setIsFormOpen(true); setEditFormData(null); setValue('title', ''); setValue('card_number', ''); }}>Add A New Master Keyfobs</button>
            </div>
        </div>}

        {keyfobs?.length > 0 && !isFormOpen && <div className={`${styles.KeyFobListSecSec}`}>
            {keyfobs?.length < 5 && <button className={`${styles.KeyFobListAddBU}`} onClick={(e) => { setIsFormOpen(true); setEditFormData(null); setValue('title', ''); setValue('card_number', ''); }}><Plus /> Keyfobs</button>}

            {keyfobs?.map(item => {
                return <KeyFobCard item={item} setIsFormOpen={setIsFormOpen.bind(this)} setEditFormData={setEditFormData.bind(this)} setOpenDeleteModal={setOpenDeleteModal.bind(this)} setDeletedId={setDeletedId.bind(this)} />
            })}
        </div>}

        {isFormOpen && <form onSubmit={handleSubmit(editFormData ? onUpdate : onSubmit)}>
            <div className={`${styles.AddKeyFobSec}`}>
                <p className={`${styles.Title}`}>{editFormData ? 'Update keyfob' : 'Add Keyfob'}</p>
                <div className={`${styles.FormRow}`}>
                    <div className={`${styles.FormGroupFullPay} FormGroup`}>
                        <Controller
                            name={`title`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                variant="outlined"
                                label="Master Card Title*"
                            />)}
                        />
                        {errors.title && (<p className={`${styles.ErrorM}`}>{errors.title.message}</p>)}
                    </div>
                    <div className={`${styles.FormGroupFullPay} FormGroup`}>
                        <Controller
                            name={`card_number`}
                            control={control}
                            render={(field) => (<NumberFormat
                                {...field}
                                customInput={TextField}
                                label="Master Card Number*"
                                id="outlined-basic"
                                variant="outlined"
                                prefix=""
                                displayType="input"
                                type={"text"}
                                thousandSeparator={false}
                                allowNegative={false}
                                decimalScale={0}
                            />)}
                        />
                        {errors.card_number && (<p className={`${styles.ErrorM}`}>{errors.card_number.message}</p>)}
                    </div>
                </div>

                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                    <button type="button" className={`${styles.ButtonVoiletLine}`} onClick={(e) => { setIsFormOpen(false); setEditFormData(null); }}>Cancel</button>
                    <button type="submit" className={`${styles.ButtonVoiletSolid}`}>{editFormData ? 'Update' : 'Submit'}</button>
                </div>}
            </div>
        </form>}

        <Dialog
            open={openDeleteModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => { setOpenDeleteModal(false); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete the master keyfob?
                <button onClick={(e) => { setOpenDeleteModal(false); }}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The master keyfob will be removed immediately. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => { deleteConfirm(); }}>Delete</Button>
                <Button className="SubmitPopupBU" onClick={(e) => { setOpenDeleteModal(false); }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    </div>
}

export default PropertyKeyFobs;